import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { setSection } from "../actions";
import style from "./Header.css";

const Header = (props) => (
    <div className={style.Header}>
        <ul className="nav nav-tabs">
            <li role="presentation" className={props.sectionActive === "Control" ? "active" : ""} onClick={() => props.setSection("Control")}>
                <Link to="/tesoreria/nominas-pago">Análisis</Link>
            </li>
            <li role="presentation" className={props.sectionActive === "Payroll" ? "active" : ""} onClick={() => props.setSection("Payroll")}>
                <Link to="/tesoreria/nominas-creadas">Nóminas Generadas</Link>
            </li>
        </ul>
    </div>
);

const mapStateToProps = (state) => {
    return {
        sectionActive: state.partnerState.sectionActive
    };
};

const mapDispatchToProps = {
    setSection
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/Header.jsx